import API from '../api';
import {
    guardianInviteCancelPath,
    guardianInvitePath,
    guardianInviteResendPath,
    guardianLinkApprovePath,
    guardianLinkRejectPath,
    guardianLinkRevokePath,
    parentAccessStatusPath,
    parentApprovedChildrenPath,
    parentChildrenPath,
    publicGuardianConfirmPath,
    publicGuardianInvitePath,
    publicGuardianRegisterPath,
    studentGuardiansPath,
} from './paths/guardianPaths';

export const fetchStudentGuardians = (studentId) =>
  API.get(studentGuardiansPath(studentId)).then((r) => r.data);

export const inviteGuardian = (studentId, email) =>
  API.post(guardianInvitePath(studentId), { email });

export const resendGuardianInvite = (studentId, inviteId) =>
  API.post(guardianInviteResendPath(studentId, inviteId));

export const cancelGuardianInvite = (studentId, inviteId) =>
  API.delete(guardianInviteCancelPath(studentId, inviteId));

export const approveGuardianLink = (linkId) =>
  API.post(guardianLinkApprovePath(linkId));

export const rejectGuardianLink = (linkId) =>
  API.post(guardianLinkRejectPath(linkId));

export const revokeGuardianLink = (linkId) =>
  API.post(guardianLinkRevokePath(linkId));

export const previewGuardianInvite = (token) =>
  API.get(publicGuardianInvitePath(token)).then((r) => r.data);

export const registerGuardianFromInvite = (token, body) =>
  API.post(publicGuardianRegisterPath(token), body);

export const confirmGuardianLinkFromInvite = (token, body) =>
  API.post(publicGuardianConfirmPath(token), body);

export const fetchParentChildren = () =>
  API.get(parentChildrenPath()).then((r) => r.data);

export const fetchApprovedParentChildren = () =>
  API.get(parentApprovedChildrenPath()).then((r) => r.data);

export const fetchParentAccessStatus = () =>
  API.get(parentAccessStatusPath()).then((r) => r.data);
